"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useState } from "react";
import { FaUserClock } from "react-icons/fa";
import { HiExclamationTriangle } from "react-icons/hi2";
import { Button } from "@/components/ui";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import Tooltip from "@/components/ui/tooltip";
import { useClockIn } from "@/hooks/use-clock-in";
import { cx } from "@/lib/tailwind-utils";
import { ClockInConfirmContent } from "./clock-in-confirm-content";
export function ClockInButton(t0) {
  const $ = _c(63);
  const {
    className
  } = t0;
  const {
    visible,
    needsClockIn,
    shouldAlertClockIn,
    shouldAlertClockOut,
    longClockInDurationMs,
    clockIn,
    clockOut,
    locations,
    locationsLoading,
    currentUser,
    timeEntry,
    todayShifts
  } = useClockIn();
  const [open, setOpen] = useState(false);
  const buttonTooltip = longClockInDurationMs !== null ? "You've been clocked in for more than 12 hours" : shouldAlertClockIn ? "Your shift is starting soon" : shouldAlertClockOut ? "Your shift is over" : undefined;
  const t1 = shouldAlertClockIn ? "ml-2 bg-status-error-bg text-status-error-text hover:md:bg-status-error-bg/80" : shouldAlertClockOut ? "ml-2 bg-decoda-purple text-destructive-foreground hover:md:bg-decoda-purple/30 hover:md:text-foreground" : undefined;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cx("text-nowrap", className, t1);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const buttonClassName = t2;
  const buttonText = needsClockIn ? "Clock In" : "Clock Out";
  if (!visible) {
    return null;
  }
  const defaultLocationId = currentUser?.primaryLocationId ?? (locations.length === 1 ? locations[0]?.id : undefined);
  const locationChoices = needsClockIn && !defaultLocationId ? locations : undefined;
  if (needsClockIn === false) {
    let t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FaUserClock />;
      t4 = () => setOpen(true);
      $[3] = t3;
      $[4] = t4;
    } else {
      t3 = $[3];
      t4 = $[4];
    }
    let t5;
    if ($[5] !== longClockInDurationMs) {
      t5 = longClockInDurationMs !== null && <HiExclamationTriangle aria-label="Clocked in for more than 12 hours" className="size-4 text-status-error-text" />;
      $[5] = longClockInDurationMs;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== buttonText || $[8] !== t5) {
      t6 = <span className="inline-flex items-center gap-1">{buttonText}{t5}</span>;
      $[7] = buttonText;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== buttonClassName || $[11] !== t6) {
      t7 = <Button variant="ghost" size="sm" className={buttonClassName} icon={t3} onClick={t4}>{t6}</Button>;
      $[10] = buttonClassName;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== buttonTooltip || $[14] !== t7) {
      t8 = <Tooltip content={buttonTooltip} showArrow={false} className="-mb-1.5" triggerAsChild={true} triggerOnlyHover={true}>{t7}</Tooltip>;
      $[13] = buttonTooltip;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    let t9;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <DialogTitle className="sr-only">Are you sure you want to clock out?</DialogTitle>;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    const t10 = timeEntry?.startTime;
    const t11 = currentUser?.id;
    let t12;
    if ($[17] !== clockOut) {
      t12 = () => {
        clockOut();
        setOpen(false);
      };
      $[17] = clockOut;
      $[18] = t12;
    } else {
      t12 = $[18];
    }
    let t13;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t13 = () => setOpen(false);
      $[19] = t13;
    } else {
      t13 = $[19];
    }
    let t14;
    if ($[20] !== locationsLoading || $[21] !== t10 || $[22] !== t11 || $[23] !== t12 || $[24] !== todayShifts) {
      t14 = <DialogContent className="max-w-sm">{t9}<div className="p-4"><ClockInConfirmContent mode="out" todayShifts={todayShifts} clockedInAt={t10} userId={t11} locationsLoading={locationsLoading} onClockIn={_temp} onClockOut={t12} onCancel={t13} /></div></DialogContent>;
      $[20] = locationsLoading;
      $[21] = t10;
      $[22] = t11;
      $[23] = t12;
      $[24] = todayShifts;
      $[25] = t14;
    } else {
      t14 = $[25];
    }
    let t15;
    if ($[26] !== open || $[27] !== t14) {
      t15 = <Dialog open={open} onOpenChange={setOpen}>{t14}</Dialog>;
      $[26] = open;
      $[27] = t14;
      $[28] = t15;
    } else {
      t15 = $[28];
    }
    let t16;
    if ($[29] !== t15 || $[30] !== t8) {
      t16 = <>{t8}{t15}</>;
      $[29] = t15;
      $[30] = t8;
      $[31] = t16;
    } else {
      t16 = $[31];
    }
    return t16;
  }
  let t3;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FaUserClock />;
    $[32] = t3;
  } else {
    t3 = $[32];
  }
  let t4;
  if ($[33] !== longClockInDurationMs) {
    t4 = longClockInDurationMs !== null && <HiExclamationTriangle aria-label="Clocked in for more than 12 hours" className="size-4 text-status-error-text" />;
    $[33] = longClockInDurationMs;
    $[34] = t4;
  } else {
    t4 = $[34];
  }
  let t5;
  if ($[35] !== buttonText || $[36] !== t4) {
    t5 = <span className="inline-flex items-center gap-1">{buttonText}{t4}</span>;
    $[35] = buttonText;
    $[36] = t4;
    $[37] = t5;
  } else {
    t5 = $[37];
  }
  let t6;
  if ($[38] !== buttonClassName || $[39] !== t5) {
    t6 = <PopoverTrigger asChild={true}><Button variant="ghost" size="sm" className={buttonClassName} icon={t3}>{t5}</Button></PopoverTrigger>;
    $[38] = buttonClassName;
    $[39] = t5;
    $[40] = t6;
  } else {
    t6 = $[40];
  }
  let t7;
  if ($[41] !== buttonTooltip || $[42] !== t6) {
    t7 = <Tooltip content={buttonTooltip} showArrow={false} className="-mb-1.5" triggerAsChild={true} triggerOnlyHover={true}>{t6}</Tooltip>;
    $[41] = buttonTooltip;
    $[42] = t6;
    $[43] = t7;
  } else {
    t7 = $[43];
  }
  const t8 = needsClockIn ? "in" : "out";
  const t9 = timeEntry?.startTime;
  const t10 = currentUser?.id;
  let t11;
  if ($[44] !== clockIn || $[45] !== defaultLocationId) {
    t11 = locationId => {
      const effectiveLocationId = locationId ?? defaultLocationId;
      if (!effectiveLocationId) {
        return;
      }
      clockIn(effectiveLocationId);
      setOpen(false);
    };
    $[44] = clockIn;
    $[45] = defaultLocationId;
    $[46] = t11;
  } else {
    t11 = $[46];
  }
  let t12;
  if ($[47] !== clockOut) {
    t12 = () => {
      clockOut();
      setOpen(false);
    };
    $[47] = clockOut;
    $[48] = t12;
  } else {
    t12 = $[48];
  }
  let t13;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setOpen(false);
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  let t14;
  if ($[50] !== locationChoices || $[51] !== locationsLoading || $[52] !== t10 || $[53] !== t11 || $[54] !== t12 || $[55] !== t8 || $[56] !== t9 || $[57] !== todayShifts) {
    t14 = <PopoverContent align="end" collisionPadding={16} className="w-72"><ClockInConfirmContent mode={t8} todayShifts={todayShifts} clockedInAt={t9} userId={t10} locations={locationChoices} locationsLoading={locationsLoading} onClockIn={t11} onClockOut={t12} onCancel={t13} /></PopoverContent>;
    $[50] = locationChoices;
    $[51] = locationsLoading;
    $[52] = t10;
    $[53] = t11;
    $[54] = t12;
    $[55] = t8;
    $[56] = t9;
    $[57] = todayShifts;
    $[58] = t14;
  } else {
    t14 = $[58];
  }
  let t15;
  if ($[59] !== open || $[60] !== t14 || $[61] !== t7) {
    t15 = <Popover open={open} onOpenChange={setOpen}>{t7}{t14}</Popover>;
    $[59] = open;
    $[60] = t14;
    $[61] = t7;
    $[62] = t15;
  } else {
    t15 = $[62];
  }
  return t15;
}
function _temp() {}